"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinceUpdated = exports.get = undefined;
exports.reducer = reducer;

var _reselect = require("reselect");

var _util = require("../../../util");

var Util = _interopRequireWildcard(_util);

var _now = require("../../now");

var Now = _interopRequireWildcard(_now);

var _raw = require("../raw");

var RawChar = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = exports.get = (0, _reselect.createSelector)(RawChar.localState, function (s) {
  return Util.Timestamp.wrap(s.updatedAt || s.createdAt);
});
var sinceUpdated = exports.sinceUpdated = Now.since(get);

function reducer(state, action) {
  switch (action.type) {
    case "BUY_UNIT":
    case "__COMBAT_RESULT":
      return action.createdAt;
    default:
      // initial state can be missing, but combineReducers() doesn't support
      // that. Null is close enough. Don't allow it in the typings though -
      // erasing it after init would be bad.
      return state || null;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/units/updated-at.js
// module id = 219
// module chunks = 0